import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { ValidationError } from '@atlassian/jira-fetch/src/index.tsx';
// eslint-disable-next-line jira/import-whitelist
import {
	calculateGpEndDateWithoutFormat,
	getGpEndDateDetails,
	type GpEndDateData,
} from '@atlassian/jira-servicedesk-premium-landing-page/src/services/use-display-gp-end-date/utils.tsx';
import { SERVICE_DESK } from '@atlassian/jira-shared-types/src/application-key.tsx';
import { STANDARD_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
import type { ResourceStoreContext, RouterDataContext } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

export default async function getGpEndDateData(
	_: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
): Promise<GpEndDateData | undefined> {
	if (
		tenantContext.appEditions.serviceDesk !== STANDARD_EDITION ||
		!tenantContext.atlassianAccountId ||
		!tenantContext.isSiteAdmin
	) {
		return;
	}

	const entitlementId = tenantContext.productEntitlementDetails?.[SERVICE_DESK]?.entitlementId;
	if (!entitlementId) {
		fireErrorAnalytics({
			meta: {
				id: 'getUserProperty',
				packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
				teamName: 'Sequoia',
			},
			error: new ValidationError('Entitlement ID is not set. Cannot fetch GP end date.'),
			skipSentry: true,
			sendToPrivacyUnsafeSplunk: true,
		});

		return undefined;
	}

	try {
		const gpEndDateDetails = await getGpEndDateDetails(tenantContext.isSiteAdmin, entitlementId);
		const gracePeriodEndDate = calculateGpEndDateWithoutFormat(
			gpEndDateDetails.maintenanceEndDate,
			gpEndDateDetails.billingPeriod,
		);
		return { gpEndDateDetails, gracePeriodEndDate };
	} catch (error: unknown) {
		fireErrorAnalytics({
			meta: {
				id: 'getGpEndDate',
				packageName: 'jiraRouterResourcesJsmGracePeriodAnnouncements',
				teamName: 'Sequoia',
			},
			error: error instanceof Error ? error : new Error(String(error)),
			skipSentry: true,
			sendToPrivacyUnsafeSplunk: true,
		});
		if (fg('jsm_gp_rethrow_err_resources')) {
			throw error;
		}
	}
}
